import React from "react";
import CustomBox from "../CustomBox/CustomBox";
import { useStyles } from "../../../assets/jss/PraisoTable";
import clsx from "clsx";

export default function Marker(props) {
  const classes = useStyles();
  return (
    <CustomBox style={{backgroundColor: props.backgroundColor}} className={clsx(classes.markerContainer)} />
  );
}
